export default __webpack_public_path__ + "static/media/certificate.0e2e7e14.svg";